export default {
  fields: {
    demo: {
      label: 'Créer une démo',
    },
    ai: {
      label: 'Optimisé par IA',
    },
    restaurant_type: {
      label: 'Sélectionner le type de restaurant',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Livraison de pizza 🍕🚗',
        PizzaNeapolitan: 'Pizza napolitaine 🍕',
        Italian: 'Italien 🇮🇹',
        Burger: 'Burger 🍔',
        Turkish: 'Turc 🇹🇷',
        Mexican: 'Mexicain 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japonais 🇯🇵',
        Vietnamese: 'Vietnamien 🇻🇳',
        Thai: 'Thaïlandais 🇹🇭',
        Asian: 'Asiatique 🍜',
        Indian: 'Indien 🥘',
        Bowls: 'Bowls 🥣',
        Vegan: 'Vegan 🥑',
        Greek: 'Grec 🏛️',
        Cafe: 'Café ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Oriental / Moyen-Orient 🧆',
        Spanish: 'Espagnol / Tapas 🇪🇸',
        Persian: 'Persan 🫖',
      },
    },
    plugins: {
      reservations: 'Réservations',
      reservations_plan_hint:
        "Les réservations nécessitent un Plan Partenaire. Il vous sera demandé de l'activer pour {{name}} lors de la création du site web.",
      catering: 'Traiteur',
      events: 'Événements',
    },
    quarter: {
      label: 'Quartier',
      address_placeholder: 'Saisir une adresse',
      quarter_placeholder: 'Saisir un quartier',
    },
    delivery_areas: {
      label: 'Quelles zones desservez-vous dans la ville ?',
      city_placeholder: 'Saisir une ville',
      district_placeholder: 'Quartier 1, Quartier 2, Quartier 3',
    },
    best_dishes: {
      label: 'Quels sont vos 3 plats phares ?',
      placeholder: 'Saisir des plats (Chicken burger, Cheese burger, etc.)',
    },
    dietary_attributes: {
      label: 'Proposez-vous des options pour les personnes souhaitant manger :',
      placeholder: 'Veuillez sélectionner des attributs alimentaires',
      types: {
        vegetarian: 'Végétarien',
        vegan: 'Vegan',
        halal: 'Halal',
        gluten_free: 'Sans gluten',
        dairy_free: 'Sans lactose',
        spicy: 'Épicé',
      },
    },
    family_owned: {
      label: 'Entreprise familiale ?',
      yes: 'Oui',
      no: 'Non',
    },
    business_founding_year: {
      label: 'Quand le restaurant a-t-il ouvert (quelle année) ?',
    },
    business_owners: {
      label: 'Propriétaires',
      placeholder: 'Saisir le propriétaire',
    },
    notes: {
      label: 'Ajouter des notes supplémentaires (facultatif)',
      placeholder: 'Ex. restaurant communautaire, initiatives, géré en couple…',
    },
    about_us: {
      title: 'À propos (Aperçu)',
    },
  },
  sections: {
    plugins: 'Plugins',
    company_info: "Générer les infos de l'entreprise",
  },
  buttons: {
    find_district: 'Trouver le quartier',
    generate: 'Générer',
    products: 'Produits',
    add: 'Ajouter',
  },
};
